import React, { Children } from 'react';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
import { useTheme } from '../providers/ThemeProvider';
export const PrivacyPolicyPage = () => {
  const {
    theme
  } = useTheme();
  const isDark = theme === 'dark';
  return <div className={`min-h-screen ${isDark ? 'bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50]' : 'bg-gradient-to-r from-gray-50 to-gray-100'}`} data-id="element-5906">
      <Navbar data-id="element-5907" />

      {/* Main Content */}
      <div className="pt-20 pb-16" data-id="element-5908">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-5909">
          <div className={`${isDark ? 'bg-navy-800' : 'bg-white'} rounded-xl shadow-lg p-8 md:p-12`} data-id="element-5910">
            <h1 className={`text-4xl font-bold mb-8 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-5911">
              Privacy Policy
            </h1>

            <div className={`prose prose-lg max-w-none ${isDark ? 'prose-invert' : ''}`} data-id="element-5912">
              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-5913">
                <strong data-id="element-5914">Effective Date:</strong> January 15, 2025
              </p>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-5915">
                Maestro Connect ("we," "us," or "our") is committed to
                protecting your privacy. This Privacy Policy explains how we
                collect, use, disclose, and safeguard your information when you
                use our platform and services (collectively, the "Services"). By
                accessing or using the Services, you agree to the terms of this
                Privacy Policy.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-5916">
                1. Information We Collect
              </h2>

              <h3 className={`text-xl font-semibold mt-6 mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-5917">
                1.1 Information You Provide
              </h3>
              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-5918">
                We collect information you provide directly to us, including:
              </p>
              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-5919">
                <li data-id="element-5920">
                  <strong data-id="element-5921">Account Information:</strong> Name, email address,
                  phone number, profile picture, and other registration details.
                </li>
                <li data-id="element-5922">
                  <strong data-id="element-5923">Profile Information:</strong> Teaching credentials,
                  instruments taught, availability, location, and other
                  professional details.
                </li>
                <li data-id="element-5924">
                  <strong data-id="element-5925">Payment Information:</strong> Payment details are
                  processed securely by third-party payment providers, including
                  Paddle. Maestro Connect does not store or have access to full
                  payment card information.
                </li>
                <li data-id="element-5926">
                  <strong data-id="element-5927">Communications:</strong> Messages, feedback, and other
                  communications you send through the Services.
                </li>
                <li data-id="element-5928">
                  <strong data-id="element-5929">Lesson and Practice Data:</strong> Lesson schedules,
                  attendance records, practice logs, progress notes, and other
                  educational content.
                </li>
              </ul>

              <h3 className={`text-xl font-semibold mt-6 mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-5930">
                1.2 Information Collected Automatically
              </h3>
              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-5931">
                When you use the Services, we automatically collect certain
                information, including:
              </p>
              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-5932">
                <li data-id="element-5933">
                  <strong data-id="element-5934">Device Information:</strong> IP address, browser type,
                  operating system, device identifiers, and mobile network
                  information.
                </li>
                <li data-id="element-5935">
                  <strong data-id="element-5936">Usage Information:</strong> Pages viewed, features
                  used, time spent on the Services, and other usage statistics.
                </li>
                <li data-id="element-5937">
                  <strong data-id="element-5938">Location Information:</strong> Approximate location
                  based on IP address or precise location if you grant
                  permission.
                </li>
                <li data-id="element-5939">
                  <strong data-id="element-5940">Cookies and Tracking Technologies:</strong> We use
                  cookies, web beacons, and similar technologies to collect
                  information about your interactions with the Services.
                </li>
              </ul>

              <h3 className={`text-xl font-semibold mt-6 mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-5941">
                1.3 Information from Third Parties
              </h3>
              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-5942">
                We may receive information about you from third parties, such as
                social media platforms (if you choose to connect your account),
                payment processors, and identity verification services.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-5943">
                2. How We Use Your Information
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-5944">
                We use the information we collect to:
              </p>
              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-5945">
                <li data-id="element-5946">Provide, maintain, and improve the Services.</li>
                <li data-id="element-5947">
                  Facilitate connections between teachers and students,
                  including matching and scheduling.
                </li>
                <li data-id="element-5948">
                  Process payments, manage subscriptions, and send transaction
                  confirmations.
                </li>
                <li data-id="element-5949">
                  Communicate with you about your account, lessons, and updates
                  to the Services.
                </li>
                <li data-id="element-5950">
                  Personalize your experience and provide tailored content and
                  recommendations.
                </li>
                <li data-id="element-5951">
                  Monitor and analyze usage trends to improve the Services.
                </li>
                <li data-id="element-5952">
                  Detect, prevent, and address fraud, security issues, and
                  technical problems.
                </li>
                <li data-id="element-5953">
                  Comply with legal obligations and enforce our Terms of
                  Service.
                </li>
                <li data-id="element-5954">
                  Send marketing communications (with your consent, where
                  required).
                </li>
              </ul>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-5955">
                3. How We Share Your Information
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-5956">
                We do not sell or rent your personal information to third
                parties. We may share your information in the following
                circumstances:
              </p>

              <h3 className={`text-xl font-semibold mt-6 mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-5957">
                3.1 With Other Users
              </h3>
              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-5958">
                Teachers and students can view each other's profile information,
                lesson schedules, and communications necessary to facilitate
                lessons.
              </p>

              <h3 className={`text-xl font-semibold mt-6 mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-5959">
                3.2 With Service Providers
              </h3>
              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-5960">
                We share information with third-party service providers who
                perform services on our behalf, such as payment processing,
                hosting, analytics, customer support, and marketing.
              </p>

              <h3 className={`text-xl font-semibold mt-6 mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-5961">
                3.3 For Legal Reasons
              </h3>
              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-5962">
                We may disclose your information if required by law, legal
                process, or government request, or if we believe disclosure is
                necessary to protect our rights, your safety, or the safety of
                others.
              </p>

              <h3 className={`text-xl font-semibold mt-6 mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-5963">
                3.4 Business Transfers
              </h3>
              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-5964">
                If we are involved in a merger, acquisition, or sale of assets,
                your information may be transferred as part of that transaction.
              </p>

              <h3 className={`text-xl font-semibold mt-6 mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-5965">
                3.5 With Your Consent
              </h3>
              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-5966">
                We may share your information with third parties when you
                provide explicit consent.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-5967">
                4. Data Security
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-5968">
                We implement reasonable security measures to protect your
                information from unauthorized access, disclosure, alteration,
                and destruction. However, no method of transmission over the
                internet or electronic storage is 100% secure. While we strive
                to protect your information, we cannot guarantee its absolute
                security.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-5969">
                5. Data Retention
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-5970">
                We retain your information for as long as necessary to provide
                the Services, comply with legal obligations, resolve disputes,
                and enforce our agreements. When your information is no longer
                needed, we will securely delete or anonymize it.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-5971">
                6. Your Rights and Choices
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-5972">
                Depending on your location, you may have the following rights:
              </p>
              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-5973">
                <li data-id="element-5974">
                  <strong data-id="element-5975">Access and Portability:</strong> Request a copy of
                  your personal information.
                </li>
                <li data-id="element-5976">
                  <strong data-id="element-5977">Correction:</strong> Update or correct inaccurate
                  information.
                </li>
                <li data-id="element-5978">
                  <strong data-id="element-5979">Deletion:</strong> Request deletion of your personal
                  information, subject to legal and contractual obligations.
                </li>
                <li data-id="element-5980">
                  <strong data-id="element-5981">Opt-Out:</strong> Unsubscribe from marketing
                  communications by following the instructions in the email or
                  contacting us.
                </li>
                <li data-id="element-5982">
                  <strong data-id="element-5983">Cookie Management:</strong> Adjust your browser
                  settings to refuse cookies or alert you when cookies are being
                  sent.
                </li>
              </ul>
              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-5984">
                To exercise these rights, please contact us at{' '}
                <a href="mailto:privacy@maestroconnect.com" className={`${isDark ? 'text-blue-400 hover:text-blue-300' : 'text-blue-600 hover:text-blue-700'} hover:underline`} data-id="element-5985">
                  privacy@maestroconnect.com
                </a>
                .
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-5986">
                7. Children's Privacy
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-5987">
                The Services are not intended for children under 13 years of
                age. We do not knowingly collect personal information from
                children under 13. If we learn that we have collected
                information from a child under 13, we will delete it promptly.
                If you believe we have collected information from a child under
                13, please contact us.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-5988">
                8. International Data Transfers
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-5989">
                Your information may be transferred to and processed in
                countries other than your country of residence. These countries
                may have data protection laws that differ from those in your
                country. By using the Services, you consent to the transfer of
                your information to these countries.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-5990">
                9. Third-Party Links
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-5991">
                The Services may contain links to third-party websites or
                services. We are not responsible for the privacy practices of
                these third parties. We encourage you to review their privacy
                policies before providing any information.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-5992">
                10. Changes to This Privacy Policy
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-5993">
                We may update this Privacy Policy from time to time. If we make
                material changes, we will notify you by email or by posting a
                notice on the Services. Your continued use of the Services after
                the changes take effect constitutes your acceptance of the
                updated Privacy Policy.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-5994">
                11. Contact Us
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-5995">
                If you have questions or concerns about this Privacy Policy or
                our data practices, please contact us:
              </p>
              <div className={`${isDark ? 'bg-navy-700' : 'bg-gray-50'} p-6 rounded-lg mb-6`} data-id="element-5996">
                <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-5997">
                  <strong data-id="element-5998">Email:</strong>{' '}
                  <a href="mailto:privacy@maestroconnect.com" className={`${isDark ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'} hover:underline`} data-id="element-5999">
                    privacy@maestroconnect.com
                  </a>
                </p>
              </div>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mt-8`} data-id="element-6000">
                Thank you for trusting Maestro Connect with your information. We
                are committed to protecting your privacy and providing a safe,
                secure platform for music education.
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer data-id="element-6001" />
    </div>;
};